export const tableschema6 = {
    "name_table": "Розділ VI. Відомості про матеріально-технічну базу закладу",
    "titles": [
        "Проєктна потужність закладу, місць",
        "Чи здається частина площі в оренду (1 - так; 0 - ні)",
        "Тип приміщень закладу (1 - власні; 2 - орендовані; 3 - частково орендовані)",
        "Власна територія для організації прогулянок на свіжому повітрі (1 - так; 0 - ні)",
        "Музична зала (1 - так; 0 - ні)",
        "Фізкультурна зала (1 - так; 0 - ні)",
        "Ресурсна кімната (1 - так; 0 - ні)",
        "Басейн (1 - так; 0 - ні)",
        "Опалення (1 - централізоване або індивідуальне опалення; 2 – пічне)",
        "Каналізація (1 - так; 0 - ні)",
        "Водогін (1 - так; 0 - ні)",
        "з гарячою водою (1 - так; 0 - ні)",
        "Пандуси та поручні (1 - так; 0 - ні)",
        "Ліфти (підйомники) (1 - так; 0 - ні)",
        "Спеціально обладнані туалетні кімнати для осіб з інвалідністю (1 - так; 0 - ні)",
        "Кількість поверхів в основній будівлі закладу, од.",
        "До якого поверху є безперешкодний доступ осіб з інвалідністю",
        "Кількість окремих будівель, од. (ряд 18 ≥ сумі ряд. 19, 20)",
        "з них",
        "перебувають в аварійному стані",
        "Наявність захисної споруди цивільного захисту (укриття) (1 - власне; 2 - орендоване; 3 – інший тип використання; 0 - відсутнє)",
        "Тип укриття (1 – найпростіше; 2 – протирадіаційне; 3 – споруда подвійного призначення з властивостями сховища; 4 – споруда подвійного призначення з протирадіаційними властивостями; 5 – сховище; 6 – модульне)",
        "Площа укриття, м2",
        "Місткість укриття, осіб"
    ],
    "parts": [
        {
            "title": "Значення",
            "subtitle": "",
            "fields": [
                "BD5000",
                "BD5010",
                "BD5020",
                "BD5030",
                "BD5040",
                "BD5050",
                "BD5060",
                "BD5070",
                "BD5080",
                "BD5090",
                "BD5100",
                "BD5101",
                "BD5110",
                "BD5120",
                "BD5130",
                "BD5140",
                "BD5150",
                "BD5160",
                "BD5161",
                "BD5162",
                "BD21",
                "BD22",
                "BD23",
                "BD24"
            ]
        }
    ],
    "shorts": {
        "titles": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24"
        ],
        "parts": [
            "1"
        ]
    }
};